import merge from 'lodash.merge';
import WG from '../modules/wg';

(function(global) {
    function Outro() {
        this.initRegistration();
        this.initAirPrTracking();
    }

    Outro.prototype.initRegistration = function() {
        var Registration = new WG.RegistrationNew();

        Registration.setOptions({
            forms: $('.section-common-outro .wg-form')
        });
        Registration.init();
    };

    Outro.prototype.initAirPrTracking = function() {
        const $trialForm = $('.section-common-outro .wg-form');

        $trialForm.on('success.wg.registration', function() {
            const addons = $trialForm.data('addons');
            const packages = $trialForm.data('packages');
            const onboarding = $trialForm.data('onboarding');

            const defaultData = {
                value: {
                    email: $(this)
                        .find('.global-form__input')
                        .val(),
                    form: $(this).data('hash'),
                    plan: $trialForm.data('plan') || 'BIZ_2021',
                    addons,
                    packages,
                    onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteData = {
                group: 'trial_forms',
                event: 'trial_form__submit',
                path: window.location.pathname
            };

            const airPrData = {
                event: 'trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteData));
            new WG.AirPrTracking(merge(defaultData, airPrData));
        });

        $trialForm.on('user.exist.wg.success.registration', function() {
            const addons = $trialForm.data('addons');
            const packages = $trialForm.data('packages');
            const onboarding = $trialForm.data('onboarding');

            const defaultData = {
                value: {
                    email: $(this)
                        .find('.global-form__input')
                        .val(),
                    form: $(this).data('hash'),
                    plan: $trialForm.data('plan') || 'BIZ_2021',
                    addons,
                    packages,
                    onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteDataForExistedUser = {
                group: 'exist_user_form_submit',
                event: 'exist_trial_form__submit',
                path: window.location.pathname
            };

            const airPrDataForExistedUser = {
                event: 'exist_trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteDataForExistedUser));
            new WG.AirPrTracking(merge(defaultData, airPrDataForExistedUser));
        });
    };

    global.widgets = global.widgets || {};
    global.widgets.Outro = Outro;
})(window.wrike);



// WEBPACK FOOTER //
// ./assets/js/common/widgets/wrike-outro.js